import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import approvals, { approvalsSaga } from './approvals';
import approval, { approvalSaga } from './approval';
import approvalMonitor, { approvalMonitorSaga } from './approvalMonitor';
import issueTaxbills, { issuedTaxbillsSaga } from './issue-taxbills';

const approvalModule = combineReducers({
  approvals,
  approval,
  approvalMonitor,
  issueTaxbills,
});

export function* approvalModuleSaga() {
  yield all([
    approvalsSaga(),
    approvalSaga(),
    approvalMonitorSaga(),
    issuedTaxbillsSaga(),
  ]);
}

export default approvalModule;
